module.exports = __webpack_public_path__ + "img/45.3e86f44b.gif";